import { selector } from 'recoil';

import { gnbDefault } from '@ecp/common/src/const/home/gnbConst';

import { menuListState } from './atom';

export const withGnbMenuList = selector({
  key: 'withGnbMenuList',
  get: ({ get }) => {
    const menuList = get(menuListState);
    return [{ ...gnbDefault, title: '홈', link: '/' }, ...menuList];
  },
});
